// modal-support.js
import axios from 'axios';
import Notification from '../notification/notification-es';
import { input } from '../input/input';

const popup = Notification({
    position: 'top-right',
    duration: 3000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

const classPrefix = 'modal-support';
const dataPrefix = 'data-modal-support';
const $modal = document.querySelector(`[${dataPrefix}]`);

if ($modal) {
    initModalOpen();
    setupModalSupport($modal);
}

function initModalOpen() {
    document.addEventListener('click', event => {
        const btn = event.target.closest('[data-modal-open="support"]');
        if (!btn || !$modal) return;
        const productId = btn.getAttribute('data-product-id') || '0';
        $modal.setAttribute(dataPrefix, productId);
        $modal.classList.add(`${classPrefix}--open`);
    });
}

export function setupModalSupport(container) {
    const $form = container.querySelector(`[${dataPrefix}-form]`);
    const $button = container.querySelector(`[${dataPrefix}-button]`);
    const $modalClose = container.querySelector(`.${classPrefix}__container-close`);

    renderFields($form);

    $modalClose.addEventListener('click', () => {
        container.classList.remove(`${classPrefix}--open`);
    });
    container.addEventListener('click', e => {
        if (!e.target.closest(`.${classPrefix}__container`)) {
            container.classList.remove(`${classPrefix}--open`);
        }
    });
    container
        .querySelector(`.${classPrefix}__container`)
        .addEventListener('click', e => e.stopPropagation());

    $button.addEventListener('click', onSubmit);

    async function onSubmit() {
        // простая валидация
        const name = $form.querySelector('input[name="name"]').value.trim();
        const email = $form.querySelector('input[name="email"]').value.trim();
        const comment = $form.querySelector('textarea[name="comment"]').value.trim();
        if (!name || !email || !comment) {
            popup.error({ message: 'Заповніть усі поля' });
            return;
        }

        $button.setAttribute('disabled', '');
        $button.textContent = 'Відправка...';

        try {
            const productId = container.getAttribute(dataPrefix);
            await axios.post('/api/product/support', {
                productId,
                name,
                email,
                comment,
            });

            popup.success({ message: 'Ваш запит успішно відправлено!' });
            container.classList.remove(`${classPrefix}--open`);
            $form.reset();
        } catch (err) {
            console.error(err);
            const text = err.response?.data?.error || 'Помилка. Спробуйте пізніше.';
            popup.error({ message: text });
        } finally {
            $button.removeAttribute('disabled');
            $button.textContent = 'Відправити';
        }
    }
}

// создаёт 3 поля: ім'я, email, коментар
function renderFields($form) {
    // очищаем от предыдущих
    $form.innerHTML = '';

    input($form, {
        type: 'text',
        label: "Ім'я",
        name: 'name',
        autocomplete: 'name',
        required: true,
    });

    input($form, {
        type: 'email',
        label: 'Електронна пошта',
        name: 'email',
        autocomplete: 'email',
        required: true,
    });

    input($form, {
        type: 'textarea',
        label: 'Коментар',
        name: 'comment',
        required: true,
        rows: 4,
    });
}
